// extracted by mini-css-extract-plugin
export var alertIcon = "_ud-0";